import Box from '@mui/material/Box';
import CircularProgress, {
	CircularProgressProps
} from '@mui/material/CircularProgress';
import type { SxProps, Theme } from '@mui/material/styles';

type Props = {
	size?: number;
	color?: CircularProgressProps['color'];
	customSx?: SxProps<Theme>;
};

export const LoadingIndicator = ({
	size = 40,
	color = 'primary',
	customSx
}: Props) => {
	return (
		<Box
			display='flex'
			alignItems='center'
			justifyContent='center'
			sx={customSx}
		>
			<CircularProgress size={size} color={color} />
		</Box>
	);
};
